import React from 'react';
import { Logo, LogoColor } from './Logo';
import { navLinks } from '../data/navigation';
import { shop } from '../data/shop';
type SiteFooterProps = {
  logoColor?: LogoColor;
};
export function SiteFooter({
  logoColor = 'purple'
}: SiteFooterProps) {
  return <footer className="border-t border-line bg-paper text-ink" data-id="element-264" data-mp="3mf6jezabdhzp">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-14 sm:grid-cols-2 lg:grid-cols-12 lg:px-8" data-id="element-265" data-mp="3hhwwbqaedif1">
        <div className="lg:col-span-5" data-id="element-266" data-mp="3difo4p3l6766">
          <Logo color={logoColor} className="h-24 w-auto" data-id="element-267" data-mp="38hrr9msoew41" />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-muted" data-id="element-268" data-mp="38ggkde3xp88p">
            Locally owned collision repair and auto painting in Helena, Montana since 1948.
          </p>
        </div>

        <nav aria-label="Footer" className="lg:col-span-3" data-id="element-269" data-mp="2yl54utkpbwzw">
          <h2 className="text-sm font-semibold" data-id="element-270" data-mp="11rtsdg21v0rz">Explore</h2>
          <ul className="mt-4 space-y-2.5" data-id="element-271" data-mp="11p7l7hj2mnaa">
            {navLinks.map(link => <li key={link.href} data-id="element-272" data-mp="wt0ehmiup7ra">
                <a href={link.href} className="text-sm text-muted transition-colors duration-150 hover:text-accent" data-id="element-273" data-mp="15r50wv9rb4ol">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="lg:col-span-4" data-id="element-274" data-mp="vtqwju13y6cn">
          <h2 className="text-sm font-semibold" data-id="element-275" data-mp="vus962xrv0wh">Visit</h2>
          <address className="mt-4 space-y-2.5 text-sm not-italic text-muted" data-id="element-276" data-mp="10str2kjgou6d">
            <a href={shop.mapsHref} target="_blank" rel="noreferrer" className="block hover:text-accent" data-id="element-277" data-mp="1ogtgnh51eejd">
              {shop.addressLine1}, {shop.addressLine2}
            </a>
            <a href={shop.phoneHref} className="block hover:text-accent" data-id="element-278" data-mp="1erjnrz2dcru7">
              {shop.phone}
            </a>
            <a href={`mailto:${shop.email}`} className="block hover:text-accent" data-id="element-279" data-mp="1jqczpn20cas9">
              {shop.email}
            </a>
          </address>
        </div>
      </div>
      <div className="border-t border-line" data-id="element-280" data-mp="27e4h352ene0e">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-6 text-xs text-muted sm:flex-row sm:justify-between lg:px-8" data-id="element-281" data-mp="2c77938rjafeh">
          <p data-id="element-282" data-mp="2m2e96qzev020">© {new Date().getFullYear()} {shop.name}, Inc. All rights reserved.</p>
          <p data-id="element-283" data-mp="2h54jda840mdn">Collision repair · Paint · Dent repair · Helena, MT</p>
        </div>
      </div>
    </footer>;
}